import React, { useMemo } from "react";
import { Stack, Box, Chip, Typography } from "@curves/ui-base";
import { ListInfo } from "@icoach/accountBook/components";
import Tablenization from "@icoach/components/Tablenization";
import { ACCOUNT_BOOK_ORDERS_ORDER_URL } from "@icoach/router/routerPath";
import { COLOR_MATCH } from "@icoach/accountBook/staticData";
import { Link } from "react-router-dom";
import { parseDate } from "@util/moment";
import { formatCurrencyFn, isEqual } from "@util/utils";
import { useAccountBookContext } from "@icoach/accountBook/components/AccountBookContext";
import { ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS } from "@icoach/constants/routerEnums";
import { OverflowMenu } from "@icoach/components";
import { buildOrderMenuData } from "@icoach/accountBook/utils/buildOrderMenuData";

const rowsLabel = [
	{
		cellKey: "orderNo",
		headerLabel: "訂單",
		align: "center",
		width: "20",
		formatCell: (orderNo, { orderID, statusColor, statusText }) => {
			return (
				<Stack direction={"column"}>
					<Link className={"mb-1"} to={ACCOUNT_BOOK_ORDERS_ORDER_URL(orderID)}>
						{orderNo}
					</Link>
					<Chip label={statusText} color={COLOR_MATCH[statusColor]} title={"訂單狀態"} />
				</Stack>
			);
		},
	},
	{
		cellKey: "receiverName",
		headerLabel: "購買人",
		width: "12",
		formatCell: (receiverName, { receiverTypeText }) => {
			return (
				<React.Fragment>
					<Typography variant={"subtitle1"} className={"p-0 font-weight-bold"}>
						{receiverName}
					</Typography>
					<Typography variant={"body2"} className={"mb-0 font-color-3"}>{`身份：${receiverTypeText}`}</Typography>
				</React.Fragment>
			);
		},
	},
	{
		cellKey: "orderTypeText",
		headerLabel: "訂單類型",
		width: "12",
		align: "center",
	},
	{
		cellKey: "payablePrice",
		headerLabel: "訂單金額",
		align: "right",
		width: "10",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "orderDate",
		headerLabel: "建立日期",
		// align: 'center',
		width: "12",
		formatCell: cellValue => {
			const _parseDate = (date, format) => {
				return parseDate(date, format, false);
			};
			return (
				<React.Fragment>
					<Typography variant={"body1"} className={"mb-0"}>
						{_parseDate(cellValue, "YYYY/MM/DD")}
					</Typography>
					<Typography variant={"body1"} className={"mb-0 font-color-3"}>
						{_parseDate(cellValue, "HH:mm")}
					</Typography>
				</React.Fragment>
			);
		},
	},
];

const campaignColumn = {
	cellKey: "campaignName",
	headerLabel: "抵用券",
	width: "15",
	formatCell: cellValue => {
		if (!cellValue || cellValue === "") {
			return <Typography className={"font-color-3"}>-</Typography>;
		}
		return cellValue;
	},
};

const AccountBookOrderOverviewTable = () => {
	const { tableData, activeTab, setBookmarkNum, refresh, dialogRef } = useAccountBookContext();
	const { list = [], totalCount, totalPage, pageIndex, pageSize } = tableData;
	const labelTitle = useMemo(
		() => {
			const columnConfigs = [...rowsLabel];
			if (isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.ON_SITE_ORDER) || isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.CAMPAIGN_ORDER)) {
				columnConfigs.push(campaignColumn);
			}
			columnConfigs.push({
				cellKey: "more",
				headerLabel: "",
				width: 6.8,
				formatCell: (_, rowData, { refresh, dialogRef }) => {
					const menuData = buildOrderMenuData(rowData, { refresh, dialogRef });
					return <OverflowMenu menuData={menuData} />;
				},
			});
			return columnConfigs;
		},
		// eslint-disable-next-line
		[activeTab]
	);

	const handlePageChange = (e, page) => setBookmarkNum(page);

	const refreshFn = refresh.current;

	return (
		<Box>
			<Stack className={"mb-1"} alignItems={"center"} justifyContent={"space-between"}>
				<Typography className={"font-weight-bold"} variant={"h5"}>
					{isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.ON_SITE_ORDER)
						? "現場訂單"
						: isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.BATCH_ORDER)
						? "批次訂單"
						: isEqual(activeTab, ACCOUNT_BOOK_ORDERS_OVERVIEW_TABS.CAMPAIGN_ORDER)
						? "抵用券訂單"
						: "全部訂單"}
				</Typography>
				<ListInfo className={"ml-auto"} pageIndex={pageIndex} padeSize={pageSize} totalCount={totalCount} isCurrentPageFirstIndex isCurrentPageLastIndex />
			</Stack>
			<Tablenization cardProps={{ className: "theme-gray overview" }} count={totalPage} page={pageIndex} onChange={handlePageChange} isPagination>
				<Tablenization.TableRowHeader headerRow={labelTitle} />
				<Tablenization.TableRowBody headerRow={labelTitle} rowsData={list} dialogRef={dialogRef} refresh={refreshFn} />
			</Tablenization>
		</Box>
	);
};

export default AccountBookOrderOverviewTable;
